<template>
  <div>
    <div class="row gutter-b">
      <div class="col-xxl-12">
        <b-card header-tag="header" footer-tag="footer">
          <template v-slot:header>
            <h6 class="mb-0">Form Loan Size</h6>
          </template>

          <div class="mb-4">
            <h6 class="mb-1">Amount <span class="text-danger">*</span></h6>
            <b-form-input
              v-model="loanSize.amount"
              type="number"
              placeholder="Masukan nominal pinjaman"
            ></b-form-input>
          </div>

          <div class="mb-4">
            <h6 class="mb-1">Admin Fee <span class="text-danger">*</span></h6>
            <b-form-input
              v-model="loanSize.admin_fee"
              type="number"
              placeholder="Masukan biaya admin"
            ></b-form-input>
          </div>

          <div class="mb-4">
            <h6 class="mb-1">Role</h6>
            <search-select
              v-model="loanSize.role_id"
              :options="roleOptions"
            ></search-select>
          </div>

          <template v-slot:footer>
            <b-button
              variant="primary"
              @click="handleSubmit"
              :disabled="loading"
              v-if="$route.name === 'loan-size-create'"
            >
              {{ loading ? "Loading..." : "Submit" }}
            </b-button>
            <b-button
              variant="warning"
              @click="handleSubmit"
              :disabled="loading"
              v-else
            >
              {{ loading ? "Loading..." : "Update" }}
            </b-button>
          </template>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "LoanSizeForm",
  data() {
    return {
      loading: false,
      loanSize: {
        amount: "",
        admin_fee: "",
        role_id: "",
      },
      roleOptions: [{ value: "", text: "Global (All Roles)" }],
    };
  },
  async mounted() {
    await this.getRoles();
    if (this.$route.name === "loan-size-edit") {
      await this.getDetail();
    }

    const lastBreadcrumb =
      this.$route.name === "loan-size-create"
        ? { title: "Create Loan Size" }
        : { title: "Edit Loan Size" };

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "Loan Size", route: "/loan-size/list" },
      lastBreadcrumb,
    ]);
  },
  methods: {
    async getRoles() {
      try {
        const { data } = await this.$axios.get(
          `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/roles`
        );
        const roles = Array.isArray(data) ? data : data?.list || [];
        this.roleOptions = [{ value: "", text: "Global (All Roles)" }];
        roles.forEach((role) => {
          this.roleOptions.push({
            value: role.id,
            text: role.name,
          });
        });
      } catch ({ response }) {
        this.$bvToast.toast(response?.data?.message ?? "Terjadi Kesalahan", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },
    async getDetail() {
      const id = this.$route.params.id;
      try {
        const { data } = await this.$axios.get(
          `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/loan-size/${id}`
        );
        const item = data?.id ? data : data?.data;
        if (item) {
          this.loanSize = {
            amount: item.amount ?? "",
            admin_fee: item.admin_fee ?? "",
            role_id: item.role_id || "",
          };
          return;
        }
      } catch (error) {
        // continue to fallback request below
      }

      try {
        const { data } = await this.$axios.get(
          `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/loan-size`
        );
        const rows = Array.isArray(data)
          ? data
          : Array.isArray(data?.list)
          ? data.list
          : [];
        const item = rows.find((row) => row.id === id);
        if (item) {
          this.loanSize = {
            amount: item.amount ?? "",
            admin_fee: item.admin_fee ?? "",
            role_id: item.role_id || "",
          };
        }
      } catch ({ response }) {
        this.$bvToast.toast(response?.data?.message ?? "Terjadi Kesalahan", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },
    async handleSubmit() {
      if (!this.loanSize.amount || !this.loanSize.admin_fee) {
        this.$bvToast.toast("Amount dan admin fee wajib diisi", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.loading = true;
      const payload = {
        json: true,
        amount: Number(this.loanSize.amount),
        admin_fee: Number(this.loanSize.admin_fee),
        role_id: this.loanSize.role_id || "",
      };

      try {
        if (this.$route.name === "loan-size-create") {
          await this.$axios.post(
            `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/loan-size`,
            payload
          );
          this.$bvToast.toast("Successfully add loan size", {
            title: "Success",
            variant: "success",
            solid: true,
          });
        } else {
          await this.$axios.put(
            `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/loan-size/${this.$route.params.id}`,
            payload
          );
          this.$bvToast.toast("Successfully update loan size", {
            title: "Success",
            variant: "success",
            solid: true,
          });
        }
        this.$router.push({ path: "/loan-size/list" });
      } catch ({ response }) {
        this.$bvToast.toast(response?.data?.message ?? "Terjadi Kesalahan", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
